// extracted by mini-css-extract-plugin
export default {"bg_wrap":"home_bg_wrap__NsbwL"};